module.exports = "/_next/static/images/CollectionCloudSources@2x-30703eb26e23d502ae6a028e3ff1133c.webp";